import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postLearnDriverFace } from '../../services/DriversService';
import { Driver, PostLearnFaceRequest } from '../../types/Drivers';

type Result = UseMutationResult<Driver, Error, PostLearnFaceRequest>;

function usePostLearnDriverFace(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postLearnDriverFace, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['driver'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostLearnDriverFace;
